/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

document.addEventListener("DOMContentLoaded", () => {
  const flickityInstances = new Map();

  function toggleFlickity() {
    const elements = document.querySelectorAll(
      ".section-feature-block-settings > .wrapper-box"
    );

    elements.forEach((element) => {
      const isSmallScreen = window.innerWidth < 750;

      if (isSmallScreen && !flickityInstances.has(element)) {
        const flkty = new Flickity(element, {
          prevNextButtons: false,
          pageDots: true,
          wrapAround: false,
          cellAlign: "left",
          contain: true
        });
        flickityInstances.set(element, flkty);
      }

      if (!isSmallScreen && flickityInstances.has(element)) {
        const flkty = flickityInstances.get(element);
        flkty.destroy();
        flickityInstances.delete(element);
      }
    });
  }

  toggleFlickity(); // Initial check on load
  window.addEventListener("resize", toggleFlickity); // Check on resize
});